import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(2),
  },
  header: {
    padding: 0,
    marginBottom: theme.spacing(2),
  },
  title: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },
}));

export default useStyles;
